<template>
  <div>
    <!-- İmg-->
    <b-img
      class="aboutImg mt-0"
      :src="imgDataUrl"
      fluid
      alt="Responsive image"
    />
    <b-tabs align="center" pills class="nav-pill-secondary mt-1">
      <b-tab
      :title="getTabTitle('KALİTE')"
        class="tabButton"
      >
        <b-card-text>
          <br /><br />
          <b-row>
            <b-col md="1"></b-col>
            <b-col md="10">
              <kalite-detail-vue
                v-if="groupedData && allDatas"
                :kaliteData="groupedData[30]"
              ></kalite-detail-vue
            ></b-col>
            <b-col md="1"></b-col>
          </b-row>
        </b-card-text>
      </b-tab>

      <b-tab
        class="tabButton"
        :title="getTabTitle('KALİTE VE GÜVENCE POLİTİKASI')"
      >
        <b-card-text>
          <br /><br />
          <b-row>
            <b-col md="1"></b-col>
            <b-col md="10"
              ><kalite-guvence-vue
                v-if="groupedData && allDatas"
                :PolitikaData="groupedData[31]"
              ></kalite-guvence-vue
            ></b-col>
            <b-col md="1"></b-col
          ></b-row>
        </b-card-text>
      </b-tab>
    </b-tabs>
    <footer-vue :AdressData="AdressData"> </footer-vue>
  </div>
</template>

<script>
import { BTabs, BTab, BRow, BCol, BCardText,BImg } from "bootstrap-vue";
import kaliteGuvenceVue from "./kaliteGuvence.vue";
import kaliteDetailVue from "./kaliteDetail.vue";
import footerVue from "../home/components/footer.vue";
import axios from "axios";

export default {
  components: {
    BTabs,
    BImg,
    BTab,
    BRow,
    BCardText,
    BCol,
    kaliteDetailVue,
    kaliteGuvenceVue,
    footerVue
  },
  data() {
    return {
      isActiveTab: "allPost",
      activeBlogId: null,
      activeAllPost: null,
      allDatas: [],
      groupedData: [],
      AdressData: [],
      imgDataUrl: '',

    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    toggleActiveTab() {
      this.isActiveTab = !this.isActiveTab;
    },
    changeActiveTab(id, tabs) {
      this.activeBlogId = { id, tabs };
    },
    changeTab(tabName) {
      this.isActiveTab = tabName;
    },
    getData() {
      // console.log("GET DATA");
      this.groupedData = [];
      const languageCode = localStorage.getItem("language") === "2" ? 2 : 1;
      axios
        .get(
          `/api/Contents/GetListByPageIdAndLanguage?id=10&language=${languageCode}`
        )
        .then((result) => {
          this.getCommunications();
          if (result.data.success) {
            // console.log("BURADA LOGA BAK");
            //    console.log(result.data.data);
            this.allDatas = result.data.data;
            this.splitData(result.data.data);
            //   console.log(this.allDatas[0]);
          } else {
            console.error("API yanıtında başarısızlık:", result.data.message);
          }
        })
        .catch((error) => {
          console.error("Catch'e düştü", error);
        });
    },
    splitData(myData) {
      myData.forEach((item) => {
        //  console.log("fdgdfgd : ",item)
        const componentId = item.componentId;
        if (!this.groupedData[componentId]) {
          this.groupedData[componentId] = [];
        }
        this.groupedData[componentId].push(item);
      });
      this.imgDataUrl = this.groupedData[29][0].image
    //  console.log(this.groupedData);
    },
    getCommunications() {
      const languageCode = localStorage.getItem("language") === "2" ? 2 : 1;
      axios
        .get(`/api/Informations/GetListByLanguage?language=${languageCode}`)
        .then((result) => {
          if (result.data.success) {
            this.AdressData = result.data.data;
            //   console.log(this.AdressData)
          } else {
            console.error("API yanıtında başarısızlık:", response.data.message);
          }
        })
        .catch((error) => {
          console.error("Catch'e düştü", error);
        });
    },
    
    getTabTitle(tabKey) {
      return localStorage.getItem("language") === "2"
        ? this.getEnglishText(tabKey)
        : this.getDefaultText(tabKey);
    },
    getEnglishText(tabKey) {
      switch (tabKey) {
        case "KALİTE":
          return "QUALİTY";
        case "KALİTE VE GÜVENCE POLİTİKASI":
          return "QUALITY AND ASSURANCE POLICY";
        default:
          return tabKey; // If no translation is available, return the original tab key
      }
    },
    getDefaultText(tabKey) {
      return tabKey; // Use the tab key as the default text
    },
  },
  watch: {
    activeBlogId(yeni, eski) {
      if (yeni && yeni.tabs) {
        this.isActiveTab = yeni.tabs;
        console.log("if e girmiş", this.isActiveTab);
      }
      console.log("if den çıkmış");
    },
  },
};
</script>
<style scoped>
.tabButton {
  font-family: "Prompt", sans-serif;
  border: 1px solid;
  background-color: #0725419a;
}
.aboutImg {
    width: 100%;
    height: 500px;
    object-fit: cover;
  }

@media (max-width: 1500px) {
  .nav-pill-secondary {
    margin-left: 0px;
    margin-top: 20px;
  }
  .aboutImg {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
}
</style>
